var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"z-slide absolute bottom-0 left-0 right-0 top-0 h-full w-full opacity-0 transition-opacity duration-1000 ease-in-out",class:[`${_vm.visible && 'opacity-100'}`]},[_c('div',{staticClass:"z-slide__content h-full w-full"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }